import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CrmStatusService } from '../../../core/data-services/crm-status.service';
import { CourtshipTypeEnum } from '../../enums/courtship-type.enum';
import { CRMCompanyStorm } from '../../models/crm/CRMCompanyStorm';
import { CRMItem } from '../../models/crm/CRMItem.model';
import { CRMStatus, CRMStatusLabels } from '../../models/crm/CRMStatus';
import { DateTime } from 'luxon';

@Component({
    selector: 'rms-crm-note-snapshot',
    templateUrl: './crm-note-snapshot.component.html',
    styleUrls: ['./crm-note-snapshot.component.scss'],
    standalone: false
})
export class CrmNoteSnapshotComponent implements OnInit, OnChanges {

  @Input() crmItem: CRMItem;

  @Output() silenceUntilChanged: EventEmitter<DateTime> = new EventEmitter<DateTime>();

  public readonly statusLabels = CRMStatusLabels;
  public readonly storm = CRMCompanyStorm;
  public readonly courtship = CourtshipTypeEnum;
  public silenceUntilDate: DateTime;
  public readonly crmStatus = CRMStatus;
  public readonly curDate = DateTime.now();
  public statusDropdownOptions: Array<{ name: CRMStatus, group: string }> = [];

  constructor(
    public crmStatusService: CrmStatusService,
  ) { }

  ngOnInit() {  }

  ngOnChanges(changes: SimpleChanges) {
    const currentCrmItem = changes.crmItem?.currentValue;
    if (currentCrmItem) {
      this.statusDropdownOptions = this.crmStatusService.getStatusDropdownOptions(changes.crmItem.currentValue);
    }
  }

  public updateSilenceUntil(value: string): void {
    if (!this.silenceUntilDate && this.crmItem.companies[0].etaki) {
      this.silenceUntilChanged.next(this.silenceUntilDate);
    }
  }

  public showSilenceUntil(): boolean {
    return this.crmStatusService.isSilenceStatus(this.crmItem.status);
  }

  public clearSilence() {
    this.silenceUntilDate = null;
    this.silenceUntilChanged.next(null);
  }

}
